import React, { useState, useEffect } from 'react';
import { Skeleton } from "@/components/ui/skeleton";
import { supabase } from '@/lib/supabase';

const CreditsDisplay = ({ userId }) => {
    const [credits, setCredits] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!userId) return;

        // Initial fetch of credits
        const fetchCredits = async () => {
            try {
                const { data, error } = await supabase
                    .from('profiles')
                    .select('credits')
                    .eq('id', userId)
                    .single();

                if (error) {
                    console.error('Error fetching credits:', error);
                    return;
                }

                if (data) {
                    console.log('Initial credits fetch:', data.credits);
                    setCredits(data.credits);
                }
            } catch (error) {
                console.error('Error in fetchCredits:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchCredits();

        // Set up real-time subscription
        const channel = supabase.channel('custom-credits-channel')
            .on(
                'postgres_changes',
                {
                    event: '*',
                    schema: 'public',
                    table: 'profiles',
                    filter: `id=eq.${userId}`,
                },
                (payload) => {
                    console.log('Received real-time update:', payload);
                    if (payload.new && typeof payload.new.credits === 'number') {
                        setCredits(payload.new.credits);
                    }
                }
            )
            .subscribe((status) => {
                console.log('Subscription status:', status);
            });

        // Cleanup subscription
        return () => {
            console.log('Cleaning up subscription');
            channel.unsubscribe();
        };
    }, [userId]);

    if (isLoading || credits === null) {
        return <Skeleton className="h-6 w-16" />;
    }

    return (
        <span className="block font-semibold text-gray-900 dark:text-white">
            {credits}
        </span>
    );
};

export default CreditsDisplay;